export const URLS = { // eslint-disable-line import/prefer-default-export
  shopTerms: "https://www.timeout.com/london/shop/terms-and-conditions"
}



/** WEBPACK FOOTER **
 ** ./src/constants/url-constants.js
 **/